
import React, { useState } from 'react';

export const TestimonialsSection: React.FC = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      text: 'Eco Loft Insulation came at the scheduled time, offered extremely competitive pricing, and finished the project in just 2 days. I\'ve been getting so many compliments on how much warmer my house feels. I\'ll be referring all of my friends.',
      rating: 5
    },
    {
      id: 2,
      name: 'James Thompson',
      text: 'Recently got my loft insulated. The old insulation was inadequate and they replaced it with high-quality materials. The team was very knowledgeable and professional. The results were outstanding. Love our energy-efficient home now.',
      rating: 5
    },
    {
      id: 3,
      name: 'Emma Davies',
      text: 'These professionals used premium insulation materials in my loft space. The transformation was incredible. Small investment but saved a lot on heating bills. They were very responsive and professional throughout. Thinking about getting the garage done now.',
      rating: 5
    },
    {
      id: 4,
      name: 'Michael Roberts',
      text: 'They did an unbelievable job transforming my loft! I researched for months and couldn\'t find what I wanted at a price I could afford. Finally found this company and it exceeded all my expectations! During these times, saving on energy bills is so important!',
      rating: 5
    },
    {
      id: 5,
      name: 'Lisa Johnson',
      text: 'This team is amazing. I got a completely insulated loft in less than 2 days. The difference in temperature is incredible. EXCELLENT WORK, I\'m very happy with the results.',
      rating: 5
    },
    {
      id: 6,
      name: 'David Wilson',
      text: 'Working with the team from initial consultation through project completion was a pleasure. We love our newly insulated home! We would recommend anyone considering loft insulation to choose Eco Loft Insulation Installers!',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Testimonials</h2>
          <p className="text-gray-700 max-w-2xl mx-auto">
            Read what our satisfied clients say about their experience with Eco Loft Insulation Installers and the quality of our work.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="bg-gray-50 rounded-lg p-8 mb-8">
              <div className="flex justify-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-6 text-center">
                "{testimonials[currentTestimonial].text}"
              </p>
              <p className="text-center font-semibold text-gray-900">
                {testimonials[currentTestimonial].name}
              </p>
            </div>

            {/* Navigation */}
            <div className="flex justify-center items-center space-x-4">
              <button 
                onClick={prevTestimonial}
                className="w-10 h-10 bg-emerald-600 text-white rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              
              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-3 h-3 rounded-full transition-colors ${
                      index === currentTestimonial ? 'bg-emerald-600' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
              
              <button 
                onClick={nextTestimonial}
                className="w-10 h-10 bg-emerald-600 text-white rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          {/* Review Platforms */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-2 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-google-fill text-white text-2xl"></i>
              </div>
              <div className="flex justify-center mb-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <a href="#" className="text-sm text-gray-600 hover:text-emerald-600">47 reviews</a>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-2 bg-red-600 rounded-lg flex items-center justify-center">
                <i className="ri-yelp-fill text-white text-2xl"></i>
              </div>
              <div className="flex justify-center mb-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <a href="#" className="text-sm text-gray-600 hover:text-emerald-600">12 reviews</a>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-2 bg-blue-800 rounded-lg flex items-center justify-center">
                <i className="ri-facebook-fill text-white text-2xl"></i>
              </div>
              <div className="flex justify-center mb-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <a href="#" className="text-sm text-gray-600 hover:text-emerald-600">23 reviews</a>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-2 bg-orange-600 rounded-lg flex items-center justify-center">
                <i className="ri-thumb-up-fill text-white text-2xl"></i>
              </div>
              <div className="flex justify-center mb-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <a href="#" className="text-sm text-gray-600 hover:text-emerald-600">8 reviews</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
